import React from 'react'
import './style.css'
import { PhoneOutlined } from '@ant-design/icons'
import LineButton from '../../components/line-button';
import FloatingButton from '../floating-button';



export default function Footer() {
    return (
        <div className="footer-container">
            <FloatingButton/>
            <div className="footer-content">
                <b style={{ color: "#FD0097", fontSize: 16 }}>สถานที่ตั้งและแผนที่</b>
                <div className="footer-content">
                    <div>บริษัท แบงค์คอกกิ๊ฟท์ จำกัด</div>
                    <div>1020 ถนนเทอดไทย แขวงตลาดพลู เขตธนบุรี กรุงเทพฯ 10600</div>
                    <div>Tel: 02-891-3300 Mobile: 081-845 2288</div>
                    <div>Email: 2288@bangkokgift.net</div>
                </div>
            </div >
            <center className="footer-content">
                <div> ©bangkokgift.net เลขทะเบียนพาณิชย์ 0105551058815</div>
                <div>
                    Power By : Kilobyte studio
                </div>
            </center>
            <div className="footer-content" style={{ textAlign: "right" }}>
                <div style={{ display: "flex", gap: 10, alignItems: "center", justifyContent: "end" }}>
                    <PhoneOutlined style={{ fontSize: 20 }} />
                    <div>081-845-2288, 02-891-3300</div></div>
                <div>เวลาทำงาน : จันทร์ - ศุกร์ 9:00-17:00</div>
                <div>เสาร์ 9:00-12:00</div>
                <div style={{marginTop:'5px'}}>
                    <LineButton width={'100%'} height={40} />
                </div>
            </div>
        </div>
    )
}
